"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveAppointmentWishAction = exports.SAVED_APPOINTMENT_WISH = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _GermanDateHelpers = require("../../../utils/GermanDateHelpers");
var _myAppointmentApi = require("../../../csc/api/myAppointmentApi");
var _myAppointmentDetailLoadAction = require("./myAppointmentDetailLoadAction");
var _myAppointmentTypes = require("../../types/myAppointmentTypes");
var _myAppointmentGapLoadAction = require("./myAppointmentGapLoadAction");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var SAVED_APPOINTMENT_WISH = exports.SAVED_APPOINTMENT_WISH = 'api/reducer/SAVE_APPOINTMENT_WISH';
var myAppointmentWishSaveAction = {
  data: (0, _propTypes.shape)({
    innerData: _propTypes.default.shape(_myAppointmentTypes.myAppointmentWish).isRequired
  }).isRequired,
  type: _propTypes.default.string.isRequired
};
var addZeros = function addZeros(str) {
  return str.toString().padStart(2, '0');
};
var saveAppointmentWishAction = exports.saveAppointmentWishAction = function saveAppointmentWishAction(dispatch, contractAccountId, assOrderId, formValues) {
  return new Promise(function (resolve) {
    if (contractAccountId && assOrderId) {
      dispatch({
        type: _myAppointmentGapLoadAction.SET_APPOINTMENT_LOADING
      });
      var proposals = formValues.proposals.map(function (nextProsal) {
        return {
          weekday: nextProsal.weekday,
          from: "".concat(addZeros(nextProsal.timeslotFromHour), ":00:00"),
          to: "".concat(addZeros(nextProsal.timeslotToHour), ":00:00")
        };
      });
      var wishData = {
        earliestDate: (0, _moment.default)(formValues.whenDate.start).format(_GermanDateHelpers.DATE_FORMAT_NATIVE),
        proposals: proposals
      };
      return (0, _myAppointmentApi.saveAppointmentWish)(contractAccountId, assOrderId, wishData).then(function () {
        dispatch({
          type: SAVED_APPOINTMENT_WISH,
          data: {
            assOrderId: assOrderId,
            innerData: wishData
          }
        });
        (0, _myAppointmentDetailLoadAction.reloadAppointment)(dispatch, contractAccountId, assOrderId);
        return resolve(true);
      }).catch(function () {
        dispatch({
          type: _myAppointmentGapLoadAction.THROW_APPOINTMENT_ERROR
        });
        return resolve(false);
      });
    }
    return resolve(false);
  });
};